<script setup>
import { computed } from "vue";
import Visa from "@/components/payment/brand/Visa.vue";
import Amex from "@/components/payment/brand/Amex.vue";
import Mastercard from "@/components/payment/brand/Mastercard.vue";
import Twint from "@/components/payment/brand/Twint.vue";
import Link from "@/components/payment/brand/Link.vue";

const props = defineProps({
  paymentMethod: {
    type: Object,
    default: null,
  },
});

// A card is the only method that has a brand. TWINT, and every wallet after it, is identified
// by the method itself — which is why the type is asked first and the brand only after.
const CARD_BRANDS = {
  visa: Visa,
  mastercard: Mastercard,
  amex: Amex,
};

const METHODS = {
  twint: Twint,
  link: Link,
};

const logo = computed(() => {
  const method = props.paymentMethod;

  if (! method?.type) {
    return null;
  }

  return method.type === 'card'
    ? CARD_BRANDS[method.brand] ?? null
    : METHODS[method.type] ?? null;
});

const last4 = computed(() => props.paymentMethod?.last4 ?? null);
</script>

<template>
  <div v-if="logo || last4" class="d-flex align-items-center">
    <component :is="logo" v-if="logo" />
    <small v-if="last4" class="text-muted ml-2">•••• {{ last4 }}</small>
  </div>
</template>
